/* eslint-disable no-underscore-dangle */
import React from 'react';
import { render } from 'react-dom';
import { createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import IndexSearchFormWrapper from './components/indexPageComponents/indexSearchformWrapper';
import rootReducer from './redux/reducers/rootReducer';
import SectionWelcome from './components/indexPageComponents/sectionWelcome';
import SectionFeaturedVehicles from './components/indexPageComponents/FeaturedVehiclesSection';
import OrderSection from './components/indexPageComponents/orderSection';
import ProgressSection from './components/indexPageComponents/progressSection';
import CatalogSection from './components/indexPageComponents/catalogSection';
import LeaseSlider from './components/indexPageComponents/leaseSlider';
import { leaseSlides } from './constants';

const store = createStore(
  rootReducer,
  compose(
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);
const App = () => (
  <Provider store={store}>
    <>
      <IndexSearchFormWrapper />
      <SectionWelcome />
      <LeaseSlider slides={leaseSlides} id="lease-slider" />
      <SectionFeaturedVehicles />
      <OrderSection />
      <ProgressSection />
      <CatalogSection />
    </>
  </Provider>
);

render(<App />, document.getElementById('root'));
